import InlineImagePlugin, {
    CreateAttachments,
    DeletePendingInlineAttachment,
} from './plugins/InlineImagePlugin';
import InlineImageResizePlugin from './plugins/InlineImageResizePlugin';
import inlineImageResizePluginTrigger from './utils/inlineImageResizePluginTrigger';
import { LazyImport, LazyModule } from 'owa-bundling';
import createLazyPlugin, { LazyPlugin } from 'owa-editor-lazy-plugin/lib/utils/createLazyPlugin';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "InlineImages" */ './lazyIndex')
);

export type LazyInlineImageResizePlugin = LazyPlugin<InlineImageResizePlugin>;

export let LazyInlineImageResizePluginClass = createLazyPlugin(
    lazyModule,
    m => m.InlineImageResizePlugin,
    'InlineImageResize',
    inlineImageResizePluginTrigger
);

export let lazyGetSelectedImage = new LazyImport(lazyModule, m => m.getSelectedImage);

export { CreateAttachments, DeletePendingInlineAttachment, InlineImagePlugin };
